import api from '../../../services/api';

class OrderTypeService {
  getOrderTypes() {
    return api.get(`/order-type`);
  }

  getOrderTypeById(id: String) {
    return api.get(`/order-type/${id}`);
  }

  createOrderType(payload: any) {
    return api.post(`/order-type`, payload);
  }

  deleteOrderType(id: String) {
    return api.delete(`/order-type/${id}`);
  }

  updateOrderType(payload: any) {
    return api.put(`/order-type`, payload);
  }
}

export default new OrderTypeService();
